import ButtonSizable from '../button-sizable/ButtonSizable';
import styles from './rounded-button-secondary-alt.module.less';

const RoundedButtonSecondaryAlt = ({ className = '', children, buttonRef, ...restProps }) => (
    <ButtonSizable className={[styles.buttonSecondaryAlt, className].join(' ')} {...restProps} ref={buttonRef}>
        {children}
    </ButtonSizable>
);

export default RoundedButtonSecondaryAlt;
